import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../components/buttons/buttons";
import Input from "../../../components/inputs/inputs";
import { Beat } from "../../../plugins/spinners.plugin";
import { history } from "../../../helpers/history";
import { cleanInput } from "../../../helpers/cleanInput";
import restaurantType from "../../../redux/restaurant/restaurantTypes";
import { searchRestaurantsAction } from "../../../redux/restaurant/restaurantActions";
import storeType from "../../../redux/stores/storeTypes";
import { searchAllStores } from "../../../redux/stores/storeActions";
import { storeInfractionAction } from "../../../redux/infraction/infractionActions";

export default function CreateInfraction() {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.infraction);
  const { search } = useSelector((state) => state.restaurant);
  const { searchStore } = useSelector((state) => state.store);
  const [submitted, setSubmitted] = useState(false);
  const [outletName, setOutletName] = useState("");
  const [outletEmail, setOutletEmail] = useState("");

  const [input, setInput] = useState({
    business_id: "",
    restaurant_id: "",
    store_id: "",
    type: "",
    title: "",
    subject: "",
    message: "",
    date: "",
  });
  const { type, business_id, title, message } = input;

  useEffect(() => {
    dispatch({ type: restaurantType["SEARCH_RESTAURANT"], payLoad: [] });
    dispatch({ type: storeType["SEARCH_STORES"], payLoad: [] });
    // eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleSearch = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setOutletName(value);

    // Search for both restaurants and stores with the same search input
    if (value.length >= 3) {
      dispatch(
        searchRestaurantsAction({
          search: value,
        })
      );
      dispatch(
        searchAllStores({
          search: value,
        })
      );
    } else if (value.length <= 3) {
      dispatch({ type: restaurantType["SEARCH_RESTAURANT"], payLoad: [] });
      dispatch({ type: storeType["SEARCH_STORES"], payLoad: [] });
    }
  };

  function selectRestaurant(result) {
    setInput((input) => ({
      ...input,
      restaurant_id: result.id ?? "",
      business_id: result.business_id,
    }));

    setOutletName(result.restaurant_name);
    setOutletEmail(result.restaurant_email);
    var mydiv = document.getElementById(result.id);
    if (result.id) {
      mydiv.style.borderColor = "border-[#D14522]";
    }
    dispatch({ type: restaurantType["SEARCH_RESTAURANT"], payLoad: [] });
    dispatch({ type: storeType["SEARCH_STORES"], payLoad: [] });
  }

  function selectStore(result) {
    setInput((input) => ({
      ...input,
      store_id: result.id ?? "",
      business_id: result.business_id,
    }));

    setOutletName(result.store_name);
    setOutletEmail(result.store_email);
    var mydiv = document.getElementById(result.id);
    if (result.id) {
      mydiv.style.borderColor = "border-[#D14522]";
    }
    dispatch({ type: restaurantType["SEARCH_RESTAURANT"], payLoad: [] });
    dispatch({ type: storeType["SEARCH_STORES"], payLoad: [] });
  }

  const handleSubmit = async () => {
    setSubmitted(true);
    let newInput = {
      ...input,
    };
    cleanInput(newInput);
    if (business_id && type && title && message) {
      try {
        const response = await dispatch(storeInfractionAction({ ...newInput }));
        if (response?.status === "success") {
          setInput({
            business_id: "",
            restaurant_id: "",
            store_id: "",
            type: "",
            title: "",
            subject: "",
            message: "",
            date: "",
          });
          history(`/admin/infractions/1`);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <div data-test="createInfraction-page">
      <form className="max-w-[630px] w-full mx-auto">
        <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-8">
          <div className="border-b border-[#E4E4F3] py-3 flex justify-center">
            <h3 className="text-lg font-medium">Create Request</h3>
          </div>

          <div className="mt-6">
            <div className="mb-4">
              <Input.Label
                title={"Request Title"}
                type="text"
                name="title"
                id="title"
                className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                placeholder="Request Title"
                onChange={handleChange}
              />
              {submitted && !title && (
                <div className="text-xs text-red-500">
                  Request title is required
                </div>
              )}
            </div>
            <div>
              <Input.Label
                title={"Outlet"}
                type="text"
                name="title"
                id="title"
                value={outletName}
                className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                placeholder="Outlet Name"
                onChange={handleSearch}
              />
              {search &&
                Array.isArray(search) &&
                search?.map((result, index) => (
                  <div
                    className="p-3 border border-primary mb-2"
                    id={result.id}
                    key={index}
                    onClick={() => selectRestaurant(result)}
                  >
                    <div className=" grid-cols-3">
                      <div className="col-span-1">
                        <div className="">
                          <h6 className="text-sm font-meduim">
                            Name: {result.restaurant_name}
                          </h6>
                        </div>
                      </div>
                      <div className="col-span-1">
                        <div>
                          <h6 className="text-sm font-meduim">
                            Phone: {result.restaurant_phone}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              {searchStore &&
                Array.isArray(searchStore) &&
                searchStore?.map((result, index) => (
                  <div
                    className="p-3 border border-primary mb-2"
                    id={result.id}
                    key={index}
                    onClick={() => selectStore(result)}
                  >
                    <div className=" grid-cols-3">
                      <div className="col-span-1">
                        <div className="">
                          <h6 className="text-sm font-meduim">
                            Name: {result.store_name}
                          </h6>
                        </div>
                      </div>
                      <div className="col-span-1">
                        <div>
                          <h6 className="text-sm font-meduim">
                            Phone: {result.store_phone}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div>
              <Input.Label
                title={"Outlet Email"}
                type="text"
                value={outletEmail}
                className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                placeholder="Outlet Email"
                disabled
              />
            </div>
            <div className="mb-4">
              <Input.Select
                title={"Request Type"}
                htmlFor={"type"}
                name={"type"}
                value={type}
                onChange={handleChange}
              >
                <option>Select Request Type</option>
                <option value={"warning issued"}>Warning Issued</option>
                <option value={"action taken"}>Action Taken</option>
              </Input.Select>
              {submitted && !type && (
                <div className="text-xs text-red-500">
                  Request type is required
                </div>
              )}
            </div>

            <Input.DatePicker
              title={"Date & Time"}
              name="date"
              id="date"
              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
              onChange={handleChange}
            />

            <div className="mb-4">
              <Input.TextArea
                title={"Message"}
                name="message"
                id="message"
                className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                onChange={handleChange}
              />
              {submitted && !message && (
                <div className="text-xs text-red-500">
                  Request message is required
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="my-6 text-center">
          <Button.Primary
            title={
              isLoading ? <Beat color={"#ffffff"} /> : "Send Compliance Request"
            }
            onClick={handleSubmit}
            className="px-5"
            type={"button"}
            disabled={isLoading}
          />
        </div>
      </form>
    </div>
  );
}
